import React from "react";
import { Message } from "semantic-ui-react";
import { map } from "lodash";


export const SimpleErrors = ({errors}) => {
  if(errors) {
    return (
      <Message error>
        <Message.List>
          {
            map(errors, (error) => {
              return (
                <Message.Item key={ error }>
                  { error }
                </Message.Item>
              )
            })
          }
        </Message.List>
      </Message>
    );
  }

  return null;
};